import { FactoryProvider, Type, inject } from '@angular/core';
import {
  BuilderService,
  SendPreviewService,
  CONTENT_BUILDER_DEPENDENCIES,
  UNSAVED_CHANGES_SERVICE,
} from '@galaxy/email-ui/builder-v3';
import { DefaultPromptBuilder } from '@galaxy/email-ui/builder-v3';
import { DynamicVariableService } from './dynamic-variable.service';
import { ImageUploadService } from '@galaxy/email-ui/email-builder/src/services/image-upload.service';
import { CrmContactProviderService } from './contact-provider.service';

export const SUPPORTED_BLOCK_TYPES = [
  'image',
  'richText',
  'heading',
  'button',
  'contactCard',
  'imageAndText',
  'simpleTable',
  'divider',
  'spacer',
  'html',
];

export const SUPPORTED_SETTINGS = ['templateName', 'subjectLine', 'previewText', 'colors', 'sizing', 'topLogo', 'footer'];

export const DEFAULT_CONTENT = {
  subjectLine: '',
  previewText: '',
  name: '',
  contentBlocks: [],
  basicSetupValid: true,
  contentSetup: {
    pageSetup: {
      outerWidth: 650,
      innerWidth: 600,
      innerHorizontalPadding: 30,
      bottomContentPadding: 60,
      topPadding: 48,
    },
    colors: {
      textColor: '#5f6368',
      titleColor: '#22292f',
      subtitleColor: '#999999',
      linkColor: '#057ec1',
      footerTextColor: '#858585',
      textBackground: '#ffffff',
      pageBackground: '#eeeeee',
    },
    topLogo: {
      defaultSourceUrl: '{{ businessLogo }}',
      showLogo: 'show',
      width: 220,
      align: 'center',
      topPadding: 32,
      bottomPadding: 8,
    },
    footer: {
      showContactInfo: true,
      showUnsubscribeLinks: true,
      text: `<p>
          {{ businessName }}, {% if businessStreetAddress %}{{ businessStreetAddress }}, {% endif %} {% if businessStreetAddress2 %}{{ businessStreetAddress2 }}, {% endif %}
          <br> {% if businessCity %}{{ businessCity }}, {% endif %} {% if businessState %}{{ businessState }}, {% endif %} {% if businessCountry %}{{ businessCountry }}, {% endif %} {{ businessPostalCode }}
          {% if businessPhoneNumber %} <br> <a href="tel:{{ businessPhoneNumber }}" style="color: inherit">{{ businessPhoneNumber }}</a> {% endif %}
    </p>
        <p>
          {{ interestInPartner }} {% if businessWebsite %}<a href="{{ businessWebsite }}" style="color: inherit; text-decoration:underline!important; display:inline-block">{{ businessName }}</a>{% endif %}
          {% if not businessWebsite %}{{ businessName }}{% endif %}.
          {{ preferNoUpdates }}
          <a href="[sendGridUnsubscribeLink]" style="color: inherit; text-decoration:underline!important;">{{ unsubscribeHere }}</a>.
        </p>`,
      disclaimer: '',
    },
  },
};

export function contentBuilderDependenciesFactory(
  builderServiceType: Type<BuilderService>,
  sendPreviewService?: Type<SendPreviewService>,
): FactoryProvider {
  return {
    provide: CONTENT_BUILDER_DEPENDENCIES,
    useFactory: () => {
      const dynamicVariableService = inject(DynamicVariableService);
      const imageUploadService = inject(ImageUploadService);
      const builderService = inject(builderServiceType);
      const contactProvider = inject(CrmContactProviderService);
      const sendPreview = sendPreviewService ? inject(sendPreviewService) : undefined;
      const unsavedChangesService = inject(UNSAVED_CHANGES_SERVICE);

      return {
        dynamicVariableService,
        imageUploadService,
        builderService,
        uploaderService: imageUploadService,
        promptBuilder: new DefaultPromptBuilder(),
        supportedBlockTypes: SUPPORTED_BLOCK_TYPES,
        supportedSettings: SUPPORTED_SETTINGS,
        contactProvider,
        sendPreviewService: sendPreview,
        defaultContent: DEFAULT_CONTENT,
        unsavedChangesService,
      };
    },
  };
}
